import { FC, useState } from 'react';
import { NavbarWrapper } from './navbar.styles';
import { Skeleton } from '@mui/material';

export const NavbarSkeleton: FC = () => {
  const chipStyles = {
    marginRight: '10px',
    borderRadius: '30px',
  }

   return (
    <NavbarWrapper>
       <Skeleton variant="rounded" width={85} height={26} sx={{ ...chipStyles }} />
       <Skeleton variant="rounded" width={65} height={26} sx={{ ...chipStyles }} />
       <Skeleton variant="rounded" width={160} height={26} sx={{ ...chipStyles  }} />
       <Skeleton variant="rounded" width={110} height={26} sx={{ ...chipStyles  }} />
       <Skeleton variant="rounded" width={60} height={26} sx={{ ...chipStyles  }} />
       <Skeleton variant="rounded" width={50} height={26} sx={{ ...chipStyles  }} />
    </NavbarWrapper>
  );
};
